import styled from 'styled-components'

import Button from '~/components/button'
import ContentBlock from '~/components/content-block'
import _Icon from '~/components/icon'
import { device, font } from '~/styles/utils'

export const MessageContentBlock = styled(ContentBlock)<{
  $offsetLeft?: number
}>`
  background-color: ${({ theme }) => theme.color.background.dark};
  color: white;
  position: absolute;
  width: calc(100vw - 32px);
  z-index: 3;
  padding: 8px;
  box-sizing: border-box;
  ${font('base')};
  text-transform: none;
  top: 20px;

  left: calc(16px - ${(props) => `${props.$offsetLeft}px`});

  @media ${device('notMobile')} {
    max-width: 380px;
    min-width: 79px;
    width: max-content;
    left: 50%;
    transform: translateX(max(-50%, -${(props) => props.$offsetLeft - 8}px));
    right: min(
      calc(${(props) => props.$offsetLeft || 0}px - 30px - 240px),
      max(-112px, calc(${(props) => props.$offsetLeft || 0}px + 60px - 100vw))
    );
  }

  p:first-child {
    margin-top: 0;
  }

  p:last-child {
    margin-bottom: 0;
  }
`

export const TooltipLink = styled(Button).attrs({ type: 'inline' })`
  && span {
    color: white;
    text-decoration: underline;
  }
`

export const Wrapper = styled.span`
  position: relative;
  padding: 2px 0;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  margin-right: auto;
`

export const Icon = styled(_Icon)`
  font-size: 14px;
  padding: 1px 0;
  color: ${({ theme }) => theme.color.icon.default};
`
